import Table from '@risksmart-app/components/src/table';

import { useGetPolicyAttestationRecordsForDocument } from '@/hooks/queries';

import { useGetRegisterTableProps } from './config';

type TabProps = {
  documentFileId: string;
};

const Tab = ({ documentFileId }: TabProps) => {
  const { data, loading } = useGetPolicyAttestationRecordsForDocument({
    queryArgs: { documentFileId },
    shouldSkip: !documentFileId,
  });
  const tableProps = useGetRegisterTableProps(data?.attestation_record);

  return <Table {...tableProps} variant={'embedded'} loading={loading} />;
};

export default Tab;
